import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {TimeService} from '../../shared/services/time.service';
import {empty} from '../../functions';
import {NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

const noop = () => {
};

export const BIRTHDATE_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputBirthdateComponent),
  multi: true
};

@Component({
    selector: 'app-input-birthdate',
    templateUrl: './input-birthdate.component.html',
    styleUrls: ['./input-birthdate.component.css'],
    providers: [BIRTHDATE_INPUT_CONTROL_VALUE_ACCESSOR],
    standalone: true,
    imports: [CommonModule, FormsModule, TranslateModule]
})
export class InputBirthdateComponent implements OnInit, ControlValueAccessor {

  @Input() minAge = 12;

  birthdate = new Date();

  year: any = null;
  month: any = null;
  day: any = null;

  yearList = <any> [];
  monthList = <any> [];

  /*
 Ng Class data interchange
  */
  // The internal data model
  private value: any = '';

  /**
   * Invoked when the model has been changed
   */
  onChange: (_: any) => void = (_: any) => {};

  /**
   * Invoked when the model has been touched
   */
  onTouched: () => void = () => {};

  /**
   * Constructor
   *
   * @param timeService
   */
  constructor(public timeService: TimeService) { }

  ngOnInit(): void {

    // Set week list data
    const date = new Date();

    this.yearList = this.timeService.getYearList(1950, date.getFullYear() - this.minAge, 'desc');
    this.monthList = this.timeService.getMonthList();
  }

  /**
   * Set date based on birthdate params
   */
  setDate() {

    // Has valid assets
    if (!empty(this.year) && !empty(this.month) && !empty(this.day) ) {

      this.birthdate.setFullYear((parseInt(this.year, 10)));
      this.birthdate.setMonth((parseInt(this.month, 10) - 1));
      this.birthdate.setDate((parseInt(this.day, 10)));

      const result = this.birthdate;
      this.writeValue(result);

    }
  }


  /**
   * Method that is invoked on an update of a model.
   */
  updateChanges() {

    // Set day / month / year model based on first model change (init value)
    if (!empty(this.value)) {

      if (empty(this.year) && empty(this.month) && empty(this.day)) {

        const birthdate = new Date(this.value);
        const year = birthdate.getFullYear();
        const month = birthdate.getMonth() + 1;
        const day = birthdate.getDate();

        this.year = year;
        this.month = month;
        this.day = day;
      }

    }

    this.onChange(this.value);
  }

  ///////////////
  // OVERRIDES //
  ///////////////

  /**
   * Writes a new item to the element.
   * @param value the value
   */
  writeValue(value: any): void {
    this.value = value;
    this.updateChanges();
  }

  /**
   * Registers a callback function that should be called when the control's value changes in the UI.
   * @param fn
   */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /**
   * Registers a callback function that should be called when the control receives a blur event.
   * @param fn
   */
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

}
